/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { FixinEIP712, FixinEIP712Interface } from "../FixinEIP712";

const _abi = [
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class FixinEIP712__factory {
  static readonly abi = _abi;
  static createInterface(): FixinEIP712Interface {
    return new utils.Interface(_abi) as FixinEIP712Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FixinEIP712 {
    return new Contract(address, _abi, signerOrProvider) as FixinEIP712;
  }
}
